
<script>
import { isNullOrEmpty } from '@/common/objectUtil';
import { mapActions, mapGetters } from 'vuex';
import { ModuleInvoice, ModuleOrganization } from '@/store/module-const';
import checkingBuyerMixin from '@/views/Invoice/InvoiceDetail/CheckingAdvance/mixins/checkingBuyerMixin';
import checkingCommonMixin from '@/views/Invoice/InvoiceDetail/CheckingAdvance/mixins/checkingCommonMixin';
import checkingSellerMixin from '@/views/Invoice/InvoiceDetail/CheckingAdvance/mixins/checkingSellerMixin';
export default {
	name: 'BaseCheckingResult',
	mixins: [checkingBuyerMixin, checkingCommonMixin, checkingSellerMixin],
	props: {},
	data() {
		return {
			statusNotChecked: this.$ms.enum.CheckingStatus.NotCheck,
		};
	},
	created() {
		const me = this;
	},
	mounted() {},

	computed: {
		...mapGetters(ModuleOrganization, ['getOrganizationWorking']),
		isCheckThirdParty() {
			const me = this;
			return (
				me.getOrganizationWorking && me.getOrganizationWorking.IsCheckThirdParty
			);
		},
	},
	methods: {
		...mapActions(ModuleInvoice, ['updateAcceptedCheckingResult']),

		/**
		 * Kiểm tra có hiển thị tiêu chí tên hóa đơn không
		 * @param {Object} currentItem - Thông tin hóa đơn hiện tại
		 * @param {Object} checkingResult - Kết quả kiểm tra
		 * @returns {boolean} True nếu cần hiển thị tiêu chí tên hóa đơn
		 * @description Kiểm tra điều kiện để hiển thị tiêu chí kiểm tra tên hóa đơn:
		 * - Không hiển thị nếu thiếu dữ liệu hoặc chưa được kiểm tra
		 * - Không hiển thị với vé tạm ứng hoặc hóa đơn thương mại NĐ70
		 * - Hiển thị nếu thiếu tên hóa đơn hoặc tên hóa đơn không hợp lệ
		 */
		checkShowInvoiceNameBase(currentItem, checkingResult) {
			const me = this;
			if (
				!currentItem ||
				!checkingResult ||
				!checkingResult.GeneralInformation ||
				checkingResult.GeneralInformation.InvoiceName == me.statusNotChecked ||
				currentItem.IsTicketAdvance ||
				me.checkInvoiceCommercialInvoiceDecree70(currentItem)
			) {
				return false;
			}
			return (
				!currentItem.InvoiceName ||
				checkingResult.GeneralInformation.InvoiceName ==
					me.$ms.enum.CheckingStatus.Invalid
			);
		},

		/**
		 * Kiểm tra có hiển thị tiêu chí ngày cấp mã không
		 * @param {Object} currentItem - Thông tin hóa đơn hiện tại
		 * @param {Object} checkingResult - Kết quả kiểm tra
		 * @returns {boolean} True nếu cần hiển thị tiêu chí ngày cấp mã
		 * @description Kiểm tra điều kiện để hiển thị tiêu chí ngày cấp mã:
		 * - Không hiển thị nếu thiếu dữ liệu hoặc chưa được kiểm tra
		 * - Không hiển thị với hóa đơn không mã, máy tính tiền, vé không mã, biên lai NĐ70
		 * - Hiển thị nếu thiếu ngày cấp mã (IssueDate)
		 */
		checkShowIssueDateBase(currentItem, checkingResult) {
			const me = this;
			if (
				!currentItem ||
				!checkingResult ||
				!checkingResult.GeneralInformation ||
				checkingResult.GeneralInformation.IssueDate == me.statusNotChecked ||
				currentItem.InvoiceCodeStatus ==
					me.$ms.enum.InvoiceCodeStatus.WithoutCode ||
				currentItem.IsValueAddedRegisterCash ||
				currentItem.IsValueAddedRegisterSales ||
				currentItem.IsValueAddedTicketWithoutCode ||
				currentItem.IsValueAddedTicketRegisterCash ||
				currentItem.IsReceiptDecree70 ||
				me.checkInvoiceCommercialInvoiceDecree70(currentItem)
			) {
				return false;
			}
			return !currentItem.IssueDate;
		},

		/**
		 * Kiểm tra có hiển thị tiêu chí đơn vị tính không
		 * @param {Object} currentItem - Thông tin hóa đơn hiện tại
		 * @param {Object} checkingResult - Kết quả kiểm tra
		 * @returns {boolean} True nếu cần hiển thị tiêu chí đơn vị tính
		 * @description Kiểm tra điều kiện để hiển thị tiêu chí đơn vị tính:
		 * - Không hiển thị nếu thiếu dữ liệu hoặc chưa được kiểm tra
		 * - Không hiển thị với biên lai NĐ70
		 * - Hiển thị nếu đơn vị tính không hợp lệ hoặc đã được cập nhật chấp nhận
		 */
		checkShowUnitNameBase(currentItem, checkingResult) {
			const me = this;
			if (
				!currentItem ||
				!checkingResult ||
				!checkingResult.Commodity ||
				checkingResult.Commodity.UnitName == me.statusNotChecked ||
				currentItem.IsReceiptDecree70
			) {
				return false;
			}

			return (
				checkingResult.Commodity.UnitName ==
					me.$ms.enum.CheckingStatus.Invalid ||
				checkingResult.Commodity.IsUpdateUnitAccepted
			);
		},

		/**
		 * Kiểm tra có hiển thị tiêu chí số lượng không
		 * @param {Object} currentItem - Thông tin hóa đơn hiện tại
		 * @param {Object} checkingResult - Kết quả kiểm tra
		 * @returns {boolean} True nếu cần hiển thị tiêu chí số lượng
		 * @description Kiểm tra điều kiện để hiển thị tiêu chí số lượng:
		 * - Không hiển thị nếu thiếu dữ liệu hoặc chưa được kiểm tra
		 * - Không hiển thị với biên lai NĐ70
		 * - Hiển thị nếu số lượng không hợp lệ hoặc đã được cập nhật chấp nhận
		 */
		checkShowQuantityBase(currentItem, checkingResult) {
			const me = this;
			if (
				!currentItem ||
				!checkingResult ||
				!checkingResult.Commodity ||
				checkingResult.Commodity.Quantity == me.statusNotChecked ||
				currentItem.IsReceiptDecree70
			) {
				return false;
			}

			return (
				checkingResult.Commodity.Quantity ==
					me.$ms.enum.CheckingStatus.Invalid ||
				checkingResult.Commodity.IsUpdateQuantityAccepted
			);
		},

		/**
		 * Kiểm tra có hiển thị tiêu chí đơn giá không
		 * @param {Object} currentItem - Thông tin hóa đơn hiện tại
		 * @param {Object} checkingResult - Kết quả kiểm tra
		 * @returns {boolean} True nếu cần hiển thị tiêu chí đơn giá
		 * @description Kiểm tra điều kiện để hiển thị tiêu chí đơn giá:
		 * - Không hiển thị nếu thiếu dữ liệu hoặc chưa được kiểm tra
		 * - Không hiển thị với biên lai NĐ70
		 * - Hiển thị nếu đơn giá không hợp lệ hoặc đã được cập nhật chấp nhận
		 */
		checkShowUnitPriceBase(currentItem, checkingResult) {
			const me = this;
			if (
				!currentItem ||
				!checkingResult ||
				!checkingResult.Commodity ||
				checkingResult.Commodity.UnitPrice == me.statusNotChecked ||
				currentItem.IsReceiptDecree70
			) {
				return false;
			}

			return (
				checkingResult.Commodity.UnitPrice ==
					me.$ms.enum.CheckingStatus.Invalid ||
				checkingResult.Commodity.IsUpdateUnitPriceAccepted
			);
		},

		/**
		 * Kiểm tra có hiển thị định mức chi phí thanh toán không
		 * @param {Object} currentItem - Thông tin hóa đơn hiện tại
		 * @param {Object} checkingResult - Kết quả kiểm tra
		 * @returns {boolean} True nếu cần hiển thị định mức chi phí
		 * @description Hiển thị định mức chi phí khi:
		 * - Có định mức chi phí và vượt định mức, hoặc
		 * - Đã chấp nhận định mức chi phí trong thanh toán
		 */
		checkShowPaymentCostNormsBase(currentItem, checkingResult) {
			const me = this;
			if (!currentItem || !checkingResult) return false;
			return (
				((currentItem.CostNorms || currentItem.CostNorms === 0) &&
					currentItem.BeyondTheNorm) ||
				(checkingResult.Payment && checkingResult.Payment.IsAcceptCostNorms)
			);
		},

		isConditionInvalid(currentItem) {
			const me = this;
			if (!currentItem || !currentItem.CheckingResult) return false;

			return (
				me.isConditionInvalidSeller(currentItem) ||
				me.isConditionInvalidBuyer(currentItem) ||
				currentItem.CheckingResult.PublishedInvoiceStatus.Status ==
					me.$ms.enum.CheckingStatus.Invalid ||
				currentItem.CheckingResult.PublishedInvoiceStatus.Status ==
					me.$ms.enum.CheckingStatus.Unknown ||
				me.getSignatureStatus(currentItem) ==
					me.$ms.enum.CheckingStatus.Invalid ||
				(me.getSignatureStatus(currentItem) ==
					me.$ms.enum.CheckingStatus.Unknown &&
					currentItem.InvoiceCreator ==
						me.$ms.enum.InvoiceCreatorFlags.AutoRead) ||
				(currentItem.CheckingResult.DeletedStatus != null &&
					currentItem.CheckingResult.DeletedStatus.Status ==
						me.$ms.enum.CheckingStatus.Invalid) ||
				(currentItem.IsInvoice123 &&
					currentItem.InfoND123.StatusExistTCT ==
						me.$ms.enum.CheckingStatus.Invalid) ||
				(currentItem.IsInvoice123 && currentItem.InfoND123.IsStopUsing) ||
				(currentItem.IsInvoice123 &&
					currentItem.InfoND123.IsInvoiceDateInStopPeriod) ||
				me.isConditionInvalidAdvance(currentItem)
			);
		},

		isConditionInvalidAdvance(currentItem) {
			const me = this;
			if (
				!currentItem ||
				!currentItem.IsCheckingAdvance ||
				!currentItem.CheckingResult
			) {
				return false;
			}

			//Các tiêu chí của kiểm tra nâng cao
			return (
				currentItem.CheckingResult.GeneralInformation.Status ==
					me.$ms.enum.CheckingStatus.Invalid ||
				currentItem.CheckingResult.Payment.Status ==
					me.$ms.enum.CheckingStatus.Invalid ||
				currentItem.CheckingResult.Commodity.Status ==
					me.$ms.enum.CheckingStatus.Invalid ||
				currentItem.CheckingResult.Payment.Status ==
					me.$ms.enum.CheckingStatus.Invalid ||
				currentItem.CheckingResult.InvoiceRelated.Status ==
					me.$ms.enum.CheckingStatus.Invalid
			);
		},

		getSignatureStatus(currentItem) {
			const me = this;
			//Nếu không phải hóa đơn 123 hoặc hóa đơn 123 không mã hoặc là hóa đơn khởi tạo từ máy tính tiền hoặc hóa đơn cũ
			if (
				!currentItem.IsInvoice123 ||
				currentItem.InvoiceCodeStatus ==
					me.$ms.enum.InvoiceCodeStatus.WithoutCode ||
				currentItem.IsRegisterCash ||
				!currentItem.IsInvoiceNewSign
			) {
				return currentItem.CheckingResult.SellerSignatureStatus.Status;
			}
			//Hóa đơn theo từng lần phát sinh không có cks NCC
			if (currentItem.IsInvoiceEachTime) {
				if (
					currentItem.CheckingResult.TaxaxionSignature.Status ==
					me.$ms.enum.CheckingStatus.Unknown
				) {
					return me.$ms.enum.CheckingStatus.Invalid;
				} else {
					return currentItem.CheckingResult.TaxaxionSignature.Status;
				}
			}
			//Là hóa đơn 123 loại có mã
			if (
				currentItem.IsInvoice123 &&
				currentItem.InvoiceCodeStatus == me.$ms.enum.InvoiceCodeStatus.WithCode
			) {
				if (
					currentItem.CheckingResult.SellerSignatureStatus.Status ==
						me.$ms.enum.CheckingStatus.Invalid ||
					currentItem.CheckingResult.TaxaxionSignature.Status ==
						me.$ms.enum.CheckingStatus.Invalid ||
					currentItem.CheckingResult.TaxaxionSignature.Status ==
						me.$ms.enum.CheckingStatus.Unknown
				) {
					return me.$ms.enum.CheckingStatus.Invalid;
				} else if (
					currentItem.CheckingResult.SellerSignatureStatus.Status ==
						me.$ms.enum.CheckingStatus.Valid &&
					currentItem.CheckingResult.TaxaxionSignature.Status ==
						me.$ms.enum.CheckingStatus.Valid
				) {
					return me.$ms.enum.CheckingStatus.Valid;
				}
			}
			return me.$ms.enum.CheckingStatus.Unchecked;
		},

		isConditionInvalidSeller(currentItem) {
			const me = this;
			if (!currentItem || !currentItem.CheckingResult) return false;

			return (
				currentItem.CheckingResult.SellerStatus.Status ==
					me.$ms.enum.CheckingStatus.Invalid ||
				(currentItem.CheckingResult.SellerStatus.Status ==
					me.$ms.enum.CheckingStatus.Unknown &&
					!currentItem.IsTicketAdvance)
			);
		},

		isConditionInvalidBuyer(currentItem) {
			return (
				currentItem.CheckingResult.BuyerStatus.Status ==
					me.$ms.enum.CheckingStatus.Invalid ||
				(currentItem.CheckingResult.BuyerStatus.Status ==
					me.$ms.enum.CheckingStatus.Unknown &&
					!currentItem.IsTicketAdvance)
			);
		},
		getMessageCheckedAdvanceBase(currentItem, checkingResult, type) {
			const me = this;
			let result = {};
			if (
				type == 'BuyerName' &&
				!checkingResult.OnInvoice &&
				checkingResult.Status == me.$ms.enum.CheckingStatus.Invalid
			) {
				result = {
					text: me.$t(`i18nInvoice.Invoice.${type}Unknown`),
					textVn: me.$t(`i18nInvoice.Invoice.${type}Unknown`, 'vi'),
				};
				return result;
			}

			//TH 3 thông tin người mua đều k có dữ liệu
			if (
				(currentItem.IsValueAddedTicketWithoutCode ||
					currentItem.IsSalesTicketWithoutCode) &&
				checkingResult &&
				(type == 'BuyerName' ||
					type == 'BuyerAddress' ||
					type == 'BuyerTaxCode') &&
				!checkingResult.OnInvoice
			) {
				result = {
					text: me.$t(`i18nInvoice.Invoice.${type}Unknown`),
					textVn: me.$t(`i18nInvoice.Invoice.${type}Unknown`, 'vi'),
				};
				return result;
			}

			if (
				checkingResult &&
				checkingResult.Status == me.$ms.enum.CheckingStatus.Valid &&
				checkingResult.AcceptOther
			) {
				result = {
					text: me.$t(`i18nInvoice.Invoice.${type}ValidChecked`),
					textVn: me.$t(`i18nInvoice.Invoice.${type}ValidChecked`, 'vi'),
				};
			} else if (
				checkingResult &&
				checkingResult.Status == me.$ms.enum.CheckingStatus.Valid
			) {
				if (
					currentItem.IsCheckReceipt &&
					(type == 'BuyerName' || type == 'BuyerAddress') &&
					!checkingResult.OnInvoice &&
					!checkingResult.IsAccepted
				) {
					result = {
						text: me.$t(`i18nInvoice.Invoice.${type}Unknown`),
						textVn: me.$t(`i18nInvoice.Invoice.${type}Unknown`, 'vi'),
					};
				} else {
					result = {
						text: me.$t(`i18nInvoice.Invoice.${type}Valid`),
						textVn: me.$t(`i18nInvoice.Invoice.${type}Valid`, 'vi'),
					};
				}
			} else if (
				checkingResult &&
				checkingResult.Status == me.$ms.enum.CheckingStatus.Unknown
			) {
				result = {
					text: me.$t(`i18nInvoice.Invoice.${type}Unknown`),
					textVn: me.$t(`i18nInvoice.Invoice.${type}Unknown`, 'vi'),
				};
			} else if (
				checkingResult &&
				checkingResult.Status == me.$ms.enum.CheckingStatus.Invalid
			) {
				result = {
					text: me.$t(`i18nInvoice.Invoice.${type}Invalid`),
					textVn: me.$t(`i18nInvoice.Invoice.${type}Invalid`, 'vi'),
				};
			} else {
				result = {
					text: me.$t(`i18nInvoice.Invoice.${type}Unchecked`),
					textVn: me.$t(`i18nInvoice.Invoice.${type}Unchecked`, 'vi'),
				};
			}
			if (currentItem.IsCheckReceipt) {
				//15.08.2022 NNTHAO Không sử dụng được .replaceAll do WebView của SME không có hàm này
				do {
					result = {
						text: result.text.replace(
							`${me.$t('i18nCommon.invoice')}`,
							`${me.$t('i18nCommon.receipt')}`
						),
						textVn: result.textVn.replace(
							`${me.$t('i18nCommon.invoice', 'vi')}`,
							`${me.$t('i18nCommon.receipt', 'vi')}`
						),
					};

					result = {
						text: result.text.replace(
							`${me.$t('i18nCommon.Invoice')}`,
							`${me.$t('i18nCommon.Receipt')}`
						),
						textVn: result.textVn.replace(
							`${me.$t('i18nCommon.Invoice', 'vi')}`,
							`${me.$t('i18nCommon.Receipt', 'vi')}`
						),
					};
				} while (
					result.text.contains(`${me.$t('i18nCommon.invoice')}`) ||
					result.text.contains(`${me.$t('i18nCommon.Invoice')}`)
				);
			}
			return result;
		},

		getIconCheckedBase(currentItem, checkingResult) {
			const me = this;
			if (
				checkingResult &&
				checkingResult.Address.Status == me.$ms.enum.CheckingStatus.Valid &&
				checkingResult.Name.Status == me.$ms.enum.CheckingStatus.Valid &&
				checkingResult.TaxCode.Status == me.$ms.enum.CheckingStatus.Valid
			) {
				return `mi-icon-v2-checking-result-green-tick`;
			} else if (
				checkingResult &&
				(checkingResult.Address.Status == me.$ms.enum.CheckingStatus.Invalid ||
					checkingResult.Name.Status == me.$ms.enum.CheckingStatus.Invalid ||
					checkingResult.TaxCode.Status == me.$ms.enum.CheckingStatus.Invalid ||
					checkingResult.Status == me.$ms.enum.CheckingStatus.Invalid)
			) {
				return `mi-icon-v2-checking-result-red-tick`;
			} else if (
				checkingResult &&
				checkingResult.Status == me.$ms.enum.CheckingStatus.Unknown
			) {
				// Tồn tại 1 thông tin đang k có thông tin
				//Với Vé GTGT có mã 123 thì vẫn hợp lệ
				return currentItem.IsTicketAdvance
					? `mi-icon-v2-checking-result-green-tick`
					: `mi-icon-v2-checking-result-red-tick`;
			}
			return `mi-icon-v2-checking-result-load-orange`;
		},

		//Dòng chi tiết có chưa HHDV hoặc CKTM hay không(tính chất == 1 || tính chất  == 3)
		checkExistItemInfo(currentItem) {
			const me = this;
			if (!currentItem || !currentItem.Items || currentItem.Items.length <= 0)
				return false;

			return currentItem.Items.find((x) => x.IsItemAndService);
		},

		getErrorCheckingResultBuyer(currentItem, checkingResult) {
			const me = this;
			let errorList = [];
			if (me.isCheckThirdParty) {
				return me.getErrorCheckingResultBuyerFroThirdParty(
					currentItem,
					checkingResult
				);
			} else {
				return me.getErrorCheckingResultBuyerNormal(
					currentItem,
					checkingResult
				);
			}
			return errorList;
		},

		getErrorCheckingResultBuyerNormal(currentItem, checkingResult) {
			const me = this;
			let errorList = [];
			//Tên người mua
			if (
				checkingResult.BuyerStatus.Name.Status ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				if (!checkingResult.BuyerStatus.Name.OnInvoice) {
					errorList.push({
						title: me.$t('i18nInvoice.Invoice.BuyerNameUnknown'),
						titleVn: `${me.$t('i18nInvoice.Invoice.BuyerNameUnknown', 'vi')}`,
						key: me.$ms.enum.CriteriaDefine.BuyerName,
						status: checkingResult.BuyerStatus.Name.Status,
					});
				} else {
					errorList.push({
						title: me.$t('i18nInvoice.Invoice.BuyerNameInvalid'),
						titleVn: `${me.$t('i18nInvoice.Invoice.BuyerNameInvalid', 'vi')}`,
						key: me.$ms.enum.CriteriaDefine.BuyerName,
						status: checkingResult.BuyerStatus.Name.Status,
					});
				}
			} else if (
				!currentItem.IsTicketAdvance &&
				checkingResult.BuyerStatus.Name.Status ==
					me.$ms.enum.CheckingStatus.Unknown
			) {
				errorList.push({
					title: me.$t('i18nInvoice.Invoice.BuyerNameUnknown'),
					titleVn: `${me.$t('i18nInvoice.Invoice.BuyerNameUnknown', 'vi')}`,
					key: me.$ms.enum.CriteriaDefine.BuyerName,
					status: checkingResult.BuyerStatus.Name.Status,
				});
			}

			if (
				checkingResult.BuyerStatus.TaxCode.Status ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				if (!checkingResult.BuyerStatus.TaxCode.OnInvoice) {
					errorList.push({
						title: me.$t('i18nInvoice.Invoice.BuyerTaxCodeUnknown'),
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.BuyerTaxCodeUnknown',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.BuyerTaxCode,
						status: checkingResult.BuyerStatus.TaxCode.Status,
					});
				} else {
					errorList.push({
						title: `${me.$t('i18nInvoice.Invoice.BuyerTaxCodeInvalid')}`,
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.BuyerTaxCodeInvalid',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.BuyerTaxCode,
						status: checkingResult.BuyerStatus.TaxCode.Status,
					});
				}
			} else if (
				!currentItem.IsTicketAdvance &&
				checkingResult.BuyerStatus.TaxCode.Status ==
					me.$ms.enum.CheckingStatus.Unknown
			) {
				errorList.push({
					title: me.$t('i18nInvoice.Invoice.BuyerTaxCodeUnknown'),
					titleVn: `${me.$t('i18nInvoice.Invoice.BuyerTaxCodeUnknown', 'vi')}`,
					key: me.$ms.enum.CriteriaDefine.BuyerTaxCode,
					status: checkingResult.BuyerStatus.TaxCode.Status,
				});
			}

			//Địa chỉ người mua
			if (
				checkingResult.BuyerStatus.Address.Status ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				if (!checkingResult.BuyerStatus.Address.OnInvoice) {
					errorList.push({
						title: me.$t('i18nInvoice.Invoice.BuyerAddressUnknown'),
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.BuyerAddressUnknown',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.BuyerAddress,
						status: checkingResult.BuyerStatus.Address.Status,
					});
				} else {
					errorList.push({
						title: `${me.$t('i18nInvoice.Invoice.BuyerAddressInvalid')}`,
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.BuyerAddressInvalid',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.BuyerAddress,
						status: checkingResult.BuyerStatus.Address.Status,
					});
				}
			} else if (
				!currentItem.IsTicketAdvance &&
				checkingResult.BuyerStatus.Address.Status ==
					me.$ms.enum.CheckingStatus.Unknown
			) {
				errorList.push({
					title: me.$t('i18nInvoice.Invoice.BuyerAddressUnknown'),
					titleVn: `${me.$t('i18nInvoice.Invoice.BuyerAddressUnknown', 'vi')}`,
					key: me.$ms.enum.CriteriaDefine.BuyerAddress,
					status: checkingResult.BuyerStatus.Address.Status,
				});
			}

			return errorList;
		},
		getErrorCheckingResultBuyerFroThirdParty(currentItem, checkingResult) {
			const me = this;
			let errorList = [];
			// MST người mua
			if (!currentItem.BuyerTaxCode) {
				errorList.push({
					title: me.$t('i18nInvoice.Invoice.BuyerTaxCodeUnknown'),
					titleVn: `${me.$t('i18nInvoice.Invoice.BuyerTaxCodeUnknown', 'vi')}`,
					key: me.$ms.enum.CriteriaDefine.BuyerTaxCode,
					status: checkingResult.BuyerStatus.TaxCode.Status,
				});
			}

			//Tên người mua
			if (
				!currentItem.BuyerName &&
				!currentItem.BuyerTaxCode &&
				!currentItem.IsCheckReceipt
			) {
				errorList.push({
					title: me.$t('i18nInvoice.Invoice.BuyerNameUnknown'),
					titleVn: `${me.$t('i18nInvoice.Invoice.BuyerNameUnknown', 'vi')}`,
					key: me.$ms.enum.CriteriaDefine.BuyerName,
					status: checkingResult.BuyerStatus.Name.Status,
				});
			} else if (
				checkingResult.BuyerStatus.Name.Status ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				if (!checkingResult.BuyerStatus.Name.OnInvoice) {
					errorList.push({
						title: me.$t('i18nInvoice.Invoice.BuyerNameUnknown'),
						titleVn: `${me.$t('i18nInvoice.Invoice.BuyerNameUnknown', 'vi')}`,
						key: me.$ms.enum.CriteriaDefine.BuyerName,
						status: checkingResult.BuyerStatus.Name.Status,
					});
				} else {
					errorList.push({
						title: me.$t('i18nInvoice.Invoice.BuyerNameInvalid'),
						titleVn: `${me.$t('i18nInvoice.Invoice.BuyerNameInvalid', 'vi')}`,
						key: me.$ms.enum.CriteriaDefine.BuyerName,
						status: checkingResult.BuyerStatus.Name.Status,
					});
				}
			}

			//Địa chỉ người mua
			if (
				!currentItem.BuyerAddress &&
				!currentItem.BuyerTaxCode &&
				!currentItem.IsCheckReceipt
			) {
				errorList.push({
					title: me.$t('i18nInvoice.Invoice.BuyerAddressUnknown'),
					titleVn: `${me.$t('i18nInvoice.Invoice.BuyerAddressUnknown', 'vi')}`,
					key: me.$ms.enum.CriteriaDefine.BuyerAddress,
					status: checkingResult.BuyerStatus.Address.Status,
				});
			} else if (
				checkingResult.BuyerStatus.Address.Status ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				if (!checkingResult.BuyerStatus.Address.OnInvoice) {
					errorList.push({
						title: me.$t('i18nInvoice.Invoice.BuyerAddressUnknown'),
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.BuyerAddressUnknown',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.BuyerAddress,
						status: checkingResult.BuyerStatus.Address.Status,
					});
				} else {
					errorList.push({
						title: `${me.$t('i18nInvoice.Invoice.BuyerAddressInvalid')}`,
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.BuyerAddressInvalid',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.BuyerAddress,
						status: checkingResult.BuyerStatus.Address.Status,
					});
				}
			} else if (
				checkingResult.BuyerStatus.Address.Status ==
				me.$ms.enum.CheckingStatus.Unknown
			) {
				errorList.push({
					title: me.$t('i18nInvoice.Invoice.BuyerAddressUnknown'),
					titleVn: `${me.$t('i18nInvoice.Invoice.BuyerAddressUnknown', 'vi')}`,
					key: me.$ms.enum.CriteriaDefine.BuyerAddress,
					status: checkingResult.BuyerStatus.Address.Status,
				});
			}
			return errorList;
		},

		getErrorCheckingResultSeller(currentItem, checkingResult) {
			const me = this;
			let errorList = [];
			//Có mã số thuế thì như rule cũ
			if (currentItem.SellerTaxCode) {
				if (
					checkingResult.SellerStatus.Name.Status ==
					me.$ms.enum.CheckingStatus.Invalid
				) {
					if (!checkingResult.SellerStatus.Name.OnInvoice) {
						errorList.push({
							title: me.$t('i18nInvoice.Invoice.SellerNameUnknown'),
							titleVn: `${me.$t(
								'i18nInvoice.Invoice.SellerNameUnknown',
								'vi'
							)}`,
							key: me.$ms.enum.CriteriaDefine.SellerName,
							status: checkingResult.SellerStatus.Name.Status,
						});
					} else {
						errorList.push({
							title: me.$t('i18nInvoice.Invoice.SellerNameInvalid'),
							titleVn: `${me.$t(
								'i18nInvoice.Invoice.SellerNameInvalid',
								'vi'
							)}`,
							key: me.$ms.enum.CriteriaDefine.SellerName,
							status: checkingResult.SellerStatus.Name.Status,
						});
					}
				}

				if (
					checkingResult.SellerStatus.Name.Status ==
					me.$ms.enum.CheckingStatus.Unknown
				) {
					errorList.push({
						title: me.$t('i18nInvoice.Invoice.SellerNameUnknown'),
						titleVn: `${me.$t('i18nInvoice.Invoice.SellerNameUnknown', 'vi')}`,
						key: me.$ms.enum.CriteriaDefine.SellerName,
						status: checkingResult.SellerStatus.Name.Status,
					});
				}

				if (
					checkingResult.SellerStatus.Address.Status ==
					me.$ms.enum.CheckingStatus.Invalid
				) {
					if (!checkingResult.SellerStatus.Address.OnInvoice) {
						errorList.push({
							title: `${me.$t('i18nInvoice.Invoice.SellerAddressUnknown')}`,
							titleVn: `${me.$t(
								'i18nInvoice.Invoice.SellerAddressUnknown',
								'vi'
							)}`,
							key: me.$ms.enum.CriteriaDefine.SellerAddress,
							status: checkingResult.SellerStatus.Address.Status,
						});
					} else {
						errorList.push({
							title: me.$t('i18nInvoice.Invoice.SellerAddressInvalid'),
							titleVn: `${me.$t(
								'i18nInvoice.Invoice.SellerAddressInvalid',
								'vi'
							)}`,
							key: me.$ms.enum.CriteriaDefine.SellerAddress,
							status: checkingResult.SellerStatus.Address.Status,
						});
					}
				}

				if (
					checkingResult.SellerStatus.Address.Status ==
					me.$ms.enum.CheckingStatus.Unknown
				) {
					errorList.push({
						title: `${me.$t('i18nInvoice.Invoice.SellerAddressUnknown')}`,
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.SellerAddressUnknown',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.SellerAddress,
						status: checkingResult.SellerStatus.Address.Status,
					});
				}
			} else {
				//Không có tên người bán
				if (!currentItem.SellerName) {
					//Cảnh báo không có tên
					errorList.push({
						title: me.$t('i18nInvoice.Invoice.SellerNameUnknown'),
						titleVn: `${me.$t('i18nInvoice.Invoice.SellerNameUnknown', 'vi')}`,
						key: me.$ms.enum.CriteriaDefine.SellerName,
						status: me.$ms.enum.CheckingStatus.Invalid,
					});
				}

				//Không có mst
				errorList.push({
					title: me.$t('i18nInvoice.Invoice.SellerTaxCodeUnKnown'),
					titleVn: `${me.$t('i18nInvoice.Invoice.SellerTaxCodeUnKnown', 'vi')}`,
					key: me.$ms.enum.CriteriaDefine.SellerTaxCode,
					status: me.$ms.enum.CheckingStatus.Invalid,
				});

				//Không có địa chỉ người bán
				if (!currentItem.SellerAddress) {
					errorList.push({
						title: me.$t('i18nInvoice.Invoice.SellerAddressUnknown'),
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.SellerAddressUnknown',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.SellerAddress,
						status: me.$ms.enum.CheckingStatus.Invalid,
					});
				}
			}

			//Địa điểm kinh doanh (HKD/CNKD) theo Nghị định 141/2026/NĐ-CP
			if (
				checkingResult.SellerStatus.BusinessLocation &&
				checkingResult.SellerStatus.BusinessLocation.Status ==
					me.$ms.enum.CheckingStatus.Invalid
			) {
				errorList.push({
					title: `${me.$t('i18nInvoice.Invoice.BusinessLocationUnknown')}`,
					titleVn: `${me.$t(
						'i18nInvoice.Invoice.BusinessLocationUnknown',
						'vi'
					)}`,
					key: me.$ms.enum.CriteriaDefine.BusinessLocation,
					status: checkingResult.SellerStatus.BusinessLocation.Status,
				});
			}
			return errorList;
		},

		getErrorCheckingResultSignatures(currentItem, checkingResult) {
			const me = this;
			let errorList = [];
			//Chữ ký số người bán
			if (
				checkingResult.SellerSignatureStatus.Status ==
				me.$ms.enum.CheckingStatus.Unknown
			) {
				if (
					checkingResult.SellerSignatureStatus.HasSigned.Status ==
					me.$ms.enum.CheckingStatus.Unknown
				) {
					errorList.push({
						title: me.$t(`i18nInvoice.Invoice.SellerSignatureStatusUnknown`),
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.SellerSignatureStatusUnknown',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.SellerSignatureStatus,
						status: checkingResult.SellerSignatureStatus.HasSigned.Status,
					});
				} else {
					if (
						checkingResult.SellerSignatureStatus.SignedDate.Status ==
						me.$ms.enum.CheckingStatus.Unknown
					) {
						errorList.push({
							title: `${me.$t(
								'i18nInvoice.InvoiceDetail.SignatureDateUnknow'
							)}`,
							titleVn: `${me.$t(
								'i18nInvoice.InvoiceDetail.SignatureDateUnknow',
								'vi'
							)}`,
							key: me.$ms.enum.CriteriaDefine.SellerSignatureStatus,
							status: checkingResult.SellerSignatureStatus.SignedDate.Status,
						});
					}
					if (
						checkingResult.SellerSignatureStatus.CertificateOwner.Status ==
						me.$ms.enum.CheckingStatus.Unknown
					) {
						errorList.push({
							title: `${me.$t(
								'i18nInvoice.InvoiceDetail.CertificateNoUnknow'
							)}`,
							titleVn: `${me.$t(
								'i18nInvoice.InvoiceDetail.CertificateNoUnknow',
								'vi'
							)}`,
							key: me.$ms.enum.CriteriaDefine.SellerSignatureStatus,
							status:
								checkingResult.SellerSignatureStatus.CertificateOwner.Status,
						});
					}
					if (
						checkingResult.SellerSignatureStatus.Certificate.Status ==
						me.$ms.enum.CheckingStatus.Unknown
					) {
						errorList.push({
							title: `${me.$t('i18nInvoice.Invoice.CertificateUnknown')}`,
							titleVn: `${me.$t(
								'i18nInvoice.Invoice.CertificateUnknown',
								'vi'
							)}`,
							key: me.$ms.enum.CriteriaDefine.SellerSignatureStatus,
							status: checkingResult.SellerSignatureStatus.Certificate.Status,
						});
					}
				}
			}

			if (
				checkingResult.SellerSignatureStatus.Status ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				if (
					!currentItem.IsValueAddedRegisterCash &&
					!currentItem.IsValueAddedRegisterSales &&
					!currentItem.IsValueAddedTicketRegisterCash &&
					checkingResult.SellerSignatureStatus.SignedDateEqInvoiceDate.Status ==
						me.$ms.enum.CheckingStatus.Invalid
				) {
					errorList.push({
						title: `${me.$t(
							'i18nInvoice.Invoice.SignedDateEqInvoiceDateInvalid'
						)}`,
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.SignedDateEqInvoiceDateInvalid',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.SellerSignatureStatus,
						status:
							checkingResult.SellerSignatureStatus.SignedDateEqInvoiceDate
								.Status,
					});
				}
				if (
					checkingResult.SellerSignatureStatus.CertificateOwner.Status ==
					me.$ms.enum.CheckingStatus.Invalid
				) {
					errorList.push({
						title: `${me.$t('i18nInvoice.Invoice.CertificateOwnerInvalid')}`,
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.CertificateOwnerInvalid',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.SellerSignatureStatus,
						status:
							checkingResult.SellerSignatureStatus.CertificateOwner.Status,
					});
				}
				if (
					checkingResult.SellerSignatureStatus.SignedDate.Status ==
					me.$ms.enum.CheckingStatus.Invalid
				) {
					errorList.push({
						title: `${me.$t('i18nInvoice.Invoice.SignedDateInvalid')}`,
						titleVn: `${me.$t('i18nInvoice.Invoice.SignedDateInvalid', 'vi')}`,
						key: me.$ms.enum.CriteriaDefine.SellerSignatureStatus,
						status: checkingResult.SellerSignatureStatus.SignedDate.Status,
					});
				}
				if (
					checkingResult.SellerSignatureStatus.DataWasModified.Status ==
					me.$ms.enum.CheckingStatus.Invalid
				) {
					errorList.push({
						title: `${me.$t('i18nInvoice.Invoice.DataWasModifiedInvalid')}`,
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.DataWasModifiedInvalid',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.SellerSignatureStatus,
						status: checkingResult.SellerSignatureStatus.DataWasModified.Status,
					});
				}
				if (
					checkingResult.SellerSignatureStatus.Certificate.Status ==
					me.$ms.enum.CheckingStatus.Invalid
				) {
					if (
						checkingResult.SellerSignatureStatus.Certificate.RdStatusCode ==
						me.$ms.enum.RdCertificateStatusCode.Suspended
					) {
						errorList.push({
							title:
								me.$t('i18nInvoice.Invoice.CertificateSuspended') +
								me.$options.filters.formatDate(
									checkingResult.SellerSignatureStatus.Certificate
										.RevocationTime
								),
							titleVn:
								me.$t('i18nInvoice.Invoice.CertificateSuspended', 'vi') +
								me.$options.filters.formatDate(
									checkingResult.SellerSignatureStatus.Certificate
										.RevocationTime
								),
							key: me.$ms.enum.CriteriaDefine.SellerSignatureStatus,
							status: checkingResult.SellerSignatureStatus.Certificate.Status,
						});
					} else if (
						checkingResult.SellerSignatureStatus.Certificate.RevocationTime ==
						null
					) {
						errorList.push({
							title: me.$t('i18nInvoice.Invoice.CertificateInvalid'),
							titleVn: `${me.$t(
								'i18nInvoice.Invoice.CertificateInvalid',
								'vi'
							)}`,
							key: me.$ms.enum.CriteriaDefine.SellerSignatureStatus,
							status: checkingResult.SellerSignatureStatus.Certificate.Status,
						});
					} else {
						errorList.push({
							title:
								me.$t('i18nInvoice.Invoice.CertificateRecall') +
								me.$options.filters.formatDate(
									checkingResult.SellerSignatureStatus.Certificate
										.RevocationTime
								),
							titleVn:
								me.$t('i18nInvoice.Invoice.CertificateRecall', 'vi') +
								me.$options.filters.formatDate(
									checkingResult.SellerSignatureStatus.Certificate
										.RevocationTime
								),
							key: me.$ms.enum.CriteriaDefine.SellerSignatureStatus,
							status: checkingResult.SellerSignatureStatus.Certificate.Status,
						});
					}
				}
			}

			//Chữ ký số cơ quan thuế
			if (
				checkingResult.TaxaxionSignature.Status ==
					me.$ms.enum.CheckingStatus.Unknown &&
				!currentItem.IsReceiptDecree70 &&
				!me.checkInvoiceCommercialInvoiceDecree70(currentItem)
			) {
				if (
					checkingResult.TaxaxionSignature.HasSigned.Status !=
					me.$ms.enum.CheckingStatus.Valid
				) {
					errorList.push({
						title: `${me.$t('i18nInvoice.Invoice.TaxaxionSignatureUnknown')}`,
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.TaxaxionSignatureUnknown',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.TaxaxionSignature,
						status: checkingResult.TaxaxionSignature.HasSigned.Status,
					});
				}
			}

			if (
				checkingResult.TaxaxionSignature.Status ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				if (
					checkingResult.TaxaxionSignature.DataWasModified.Status ==
					me.$ms.enum.CheckingStatus.Invalid
				) {
					errorList.push({
						title: `${me.$t('i18nInvoice.Invoice.DataWasModifiedInvalid')}`,
						titleVn: `${me.$t(
							'i18nInvoice.Invoice.DataWasModifiedInvalid',
							'vi'
						)}`,
						key: me.$ms.enum.CriteriaDefine.TaxaxionSignature,
						status: checkingResult.TaxaxionSignature.DataWasModified.Status,
					});
				}
			}
			return errorList;
		},

		getErrorCheckingResultActiveStatus(currentItem, checkingResult) {
			const me = this;
			let errorList = [];
			if (
				checkingResult.SellerStatus.ActiveStatus.Status ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				let textInfo;
				if (
					isNullOrEmpty(checkingResult.SellerStatus.ActiveStatus.StatusInfoText)
				) {
					textInfo = me.getMessageChecked(
						checkingResult.SellerStatus.ActiveStatus,
						'SellerActiveStatus'
					);
				} else {
					textInfo = me.$ms.commonFunc.getStatusInfoText(
						checkingResult.SellerStatus.ActiveStatus
					);
				}
				errorList.push({
					title: textInfo.text,
					titleVn: textInfo.textVn,
					key: me.$ms.enum.CriteriaDefine.ActiveStatus,
					status: checkingResult.SellerStatus.ActiveStatus.Status,
				});
			}

			return errorList;
		},

		checkCriteriaAVASupport(criteriaDefine) {
			const me = this;

			// Ẩn AVA explain với cơ cấu đặc thù cho các tiêu chí người mua
			if (me.isCheckThirdParty) {
				const buyerCriteria = [
					me.$ms.enum.CriteriaDefine.BuyerName,
					me.$ms.enum.CriteriaDefine.BuyerTaxCode,
					me.$ms.enum.CriteriaDefine.BuyerAddress,
				];
				if (buyerCriteria.includes(criteriaDefine)) {
					return false;
				}
			}

			return (
				window.__env.AvaExplainConfig &&
				window.__env.AvaExplainConfig.CriteriaInvoice &&
				window.__env.AvaExplainConfig.CriteriaInvoice.length > 0 &&
				window.__env.AvaExplainConfig.CriteriaInvoice.includes(criteriaDefine)
			);
		},

		//Các TH định nghĩa trạng thái tổng của thông tin người mua
		getDefineBuyerStatus(checkingResult, currentItem) {
			const me = this;
			if (
				checkingResult &&
				checkingResult.Address.Status == me.$ms.enum.CheckingStatus.Valid &&
				checkingResult.Name.Status == me.$ms.enum.CheckingStatus.Valid &&
				checkingResult.TaxCode.Status == me.$ms.enum.CheckingStatus.Valid
			) {
				return me.$ms.enum.CheckingStatus.Valid;
			} else if (
				checkingResult &&
				(checkingResult.Address.Status == me.$ms.enum.CheckingStatus.Invalid ||
					checkingResult.Name.Status == me.$ms.enum.CheckingStatus.Invalid ||
					checkingResult.TaxCode.Status == me.$ms.enum.CheckingStatus.Invalid ||
					checkingResult.Status == me.$ms.enum.CheckingStatus.Invalid)
			) {
				return me.$ms.enum.CheckingStatus.Invalid;
			}

			if (
				checkingResult &&
				checkingResult.Status == me.$ms.enum.CheckingStatus.Unknown
			) {
				//Các TH này thì thông tin này thì thông tin người mua vẫn hợp lệ
				const buyerValid =
					currentItem.IsTicketAdvance ||
					(currentItem.IsReceiptDecree70 && !currentItem.BuyerTaxCode);
				return buyerValid
					? me.$ms.enum.CheckingStatus.Valid
					: me.$ms.enum.CheckingStatus.Invalid;
			}
			return me.$ms.enum.CheckingStatus.Unknown;
		},

		//Các TH định nghĩa trạng thái tổng của thông tin người bán
		getDefineSellerStatus(checkingResult) {
			const me = this;
			if (
				checkingResult &&
				checkingResult.Address.Status == me.$ms.enum.CheckingStatus.Valid &&
				checkingResult.Name.Status == me.$ms.enum.CheckingStatus.Valid &&
				(checkingResult.BusinessLocation.Status ==
					me.$ms.enum.CheckingStatus.Unchecked ||
					checkingResult.BusinessLocation.Status ==
						me.$ms.enum.CheckingStatus.Valid)
			) {
				return me.$ms.enum.CheckingStatus.Valid;
			} else if (
				checkingResult &&
				(checkingResult.Address.Status == me.$ms.enum.CheckingStatus.Invalid ||
					checkingResult.Name.Status == me.$ms.enum.CheckingStatus.Invalid ||
					checkingResult.BusinessLocation.Status ==
						me.$ms.enum.CheckingStatus.Invalid)
			) {
				return me.$ms.enum.CheckingStatus.Invalid;
			} else if (
				checkingResult &&
				checkingResult.Address.Status == me.$ms.enum.CheckingStatus.Unknown &&
				checkingResult.Name.Status == me.$ms.enum.CheckingStatus.Unknown
			) {
				return me.$ms.enum.CheckingStatus.Invalid;
			} else if (
				checkingResult &&
				(checkingResult.Address.Status == me.$ms.enum.CheckingStatus.Unknown ||
					checkingResult.Name.Status == me.$ms.enum.CheckingStatus.Unknown) &&
				checkingResult.Address.Status !=
					me.$ms.enum.CheckingStatus.ErrorOnChecking &&
				checkingResult.Name.Status != me.$ms.enum.CheckingStatus.ErrorOnChecking
			) {
				return me.$ms.enum.CheckingStatus.Invalid;
			}

			return me.$ms.enum.CheckingStatus.Unknown;
		},

		/**
		 * Hàm check để hiển thị thông tin cks với TH hóa đơn khởi tạo từ máy tính tiền
		 */
		isShowSignatureInfoBase(currentItem, checkingResult) {
			const me = this;
			//Hóa đơn nhập tay không hiển thị thông tin CKS
			//HĐ Không mã theo hình thức BTH
			if (
				currentItem.InvoiceCreator == me.$ms.enum.InvoiceCreatorFlags.Handing ||
				(currentItem.IsInvoiceSendBySumary &&
					currentItem.InvoiceCodeStatus ==
						me.$ms.enum.InvoiceCodeStatus.WithoutCode)
			) {
				return false;
			} else if (
				(currentItem.IsRegisterCash || currentItem.IsTicketNoCode) &&
				checkingResult.SellerSignatureStatus &&
				checkingResult.SellerSignatureStatus.IsNotChecking
			) {
				return false;
			} else {
				return true;
			}
		},

		getTitleCheckingInvoiceNo(currentItem, checkingResult) {
			const me = this;
			if (!currentItem.InvoiceNo) {
				return {
					title: currentItem.IsReceiptDecree70
						? me.$t('i18nInvoice.Invoice.CheckingResult.NoReceiptNumber')
						: me.$t('i18nInvoice.Invoice.CheckingResult.NoInvoiceNumber'),
					titleVn: currentItem.IsReceiptDecree70
						? me.$t('i18nInvoice.Invoice.CheckingResult.NoReceiptNumber', 'vi')
						: me.$t('i18nInvoice.Invoice.CheckingResult.NoInvoiceNumber', 'vi'),
				};
			}

			if (
				checkingResult.GeneralInformation.InvoiceNo ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				const lengthInvoiceNo = currentItem.IsReceiptDecree70 ? 7 : 8;
				return {
					title: me
						.$t('i18nInvoice.Invoice.CheckingResult')
						.InvoiceNoInvalid(lengthInvoiceNo),
					titleVn: me
						.$t('i18nInvoice.Invoice.CheckingResult', 'vi')
						.InvoiceNoInvalid(lengthInvoiceNo),
				};
			}
			return '';
		},

		getTitleCheckingInvoiceName(currentItem, checkingResult) {
			const me = this;
			if (!currentItem.InvoiceName) {
				return {
					title: me.$t('i18nInvoice.AvaCheckResult.InvoiceNameNoInfomation'),
					titleVn: me.$t(
						'i18nInvoice.AvaCheckResult.InvoiceNameNoInfomation',
						'vi'
					),
				};
			}
			return {
				title: me.$t('i18nInvoice.CheckingResult.InvoiceNameInvalid'),
				titleVn: me.$t('i18nInvoice.CheckingResult.InvoiceNameInvalid', 'vi'),
			};
		},

		getTitleCheckingIssueDate(currentItem, checkingResult) {
			const me = this;
			if (
				currentItem.InvoiceCodeStatus ==
					me.$ms.enum.InvoiceCodeStatus.WithCode &&
				!currentItem.IssueDate
			) {
				return {
					title: me.$t('i18nInvoice.AvaCheckResult.IssueDateNoInfomation'),
					titleVn: me.$t(
						'i18nInvoice.AvaCheckResult.IssueDateNoInfomation',
						'vi'
					),
				};
			}
			return '';
		},

		getTitleCheckingExchangeRate(cuurentItem, checkingResult) {
			const me = this;

			if (
				me.checkingResult.GeneralInformation.IsAcceptedExchangeRate &&
				me.checkingResult.GeneralInformation.ExchangeRate == me.validStatus
			) {
				return {
					title: me.$t('i18nInvoice.AvaCheckResult.ExchangeRateValid'),
					titleVn: me.$t('i18nInvoice.AvaCheckResult.ExchangeRateValid', 'vi'),
				};
			}

			if (
				!me.currentItem.ExchangeRateXML &&
				me.currentItem.ExchangeRateXML != 0
			) {
				return {
					title: me.$t('i18nInvoice.AvaCheckResult.ExchangeRateNoInfomation'),
					titleVn: me.$t(
						'i18nInvoice.AvaCheckResult.ExchangeRateNoInfomation',
						'vi'
					),
				};
			}

			if (
				me.currentItem.CcyCodeXML &&
				me.currentItem.CcyCodeXML.toLowerCase() == 'VND'.toLowerCase() &&
				me.currentItem.CcyCodeXML != 1
			) {
				return {
					title: me.$t(
						'i18nInvoice.CheckingResult.TootltipInvalidExchangeRate1'
					),
					titleVn: me.$t(
						'i18nInvoice.CheckingResult.TootltipInvalidExchangeRate1',
						'vi'
					),
				};
			}

			return {
				title: me.$t('i18nInvoice.CheckingResult.TootltipInvalidExchangeRate'),
				titleVn: me.$t(
					'i18nInvoice.CheckingResult.TootltipInvalidExchangeRate',
					'vi'
				),
			};
		},

		getTitleCheckingInvoiceRelatedTemplateNo(currentItem, checkingResult) {
			const me = this;
			if (
				checkingResult.InvoiceRelated.TemplateNo !=
				me.$ms.enum.CheckingStatus.Invalid
			) {
				return '';
			}

			return {
				title: currentItem.IsReceiptDecree70
					? me.$t(
							'i18nInvoice.CheckingResult.InvoiceRelated.MissedTemplateNoReceipt2'
					  )
					: me.$t(
							'i18nInvoice.CheckingResult.InvoiceRelated.MissedTemplateNo2'
					  ),
				titleVn: currentItem.IsReceiptDecree70
					? me.$t(
							'i18nInvoice.CheckingResult.InvoiceRelated.MissedTemplateNoReceipt2',
							'vi'
					  )
					: me.$t(
							'i18nInvoice.CheckingResult.InvoiceRelated.MissedTemplateNo2',
							'vi'
					  ),
			};
		},

		getTitleCheckingInvoiceRelatedSeries(currentItem, checkingResult) {
			const me = this;
			if (
				checkingResult.InvoiceRelated.Series ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				return {
					title: currentItem.IsReceiptDecree70
						? me.$t(
								'i18nInvoice.CheckingResult.InvoiceRelated.MissedSeriesReceipt2'
						  )
						: me.$t('i18nInvoice.CheckingResult.InvoiceRelated.MissedSeries2'),
					titleVn: currentItem.IsReceiptDecree70
						? me.$t(
								'i18nInvoice.CheckingResult.InvoiceRelated.MissedSeriesReceipt2',
								'vi'
						  )
						: me.$t(
								'i18nInvoice.CheckingResult.InvoiceRelated.MissedSeries2',
								'vi'
						  ),
				};
			}
			return '';
		},

		getTitleCheckingInvoiceRelatedNo(currentItem, checkingResult) {
			const me = this;
			if (
				checkingResult.InvoiceRelated.InvoiceNo ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				return {
					title: currentItem.IsReceiptDecree70
						? me.$t(
								'i18nInvoice.CheckingResult.InvoiceRelated.MissedInvoiceNoReceipt2'
						  )
						: me.$t(
								'i18nInvoice.CheckingResult.InvoiceRelated.MissedInvoiceNo2'
						  ),
					titleVn: currentItem.IsReceiptDecree70
						? me.$t(
								'i18nInvoice.CheckingResult.InvoiceRelated.MissedInvoiceNoReceipt2',
								'vi'
						  )
						: me.$t(
								'i18nInvoice.CheckingResult.InvoiceRelated.MissedInvoiceNo2',
								'vi'
						  ),
				};
			}
			return '';
		},

		getTitleCheckingInvoiceRelatedDate(currentItem, checkingResult) {
			const me = this;
			if (
				checkingResult.InvoiceRelated.InvoiceDate ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				return {
					title: currentItem.IsReceiptDecree70
						? me.$t(
								'i18nInvoice.CheckingResult.InvoiceRelated.MissedInvoiceDateReceipt2'
						  )
						: me.$t(
								'i18nInvoice.CheckingResult.InvoiceRelated.MissedInvoiceDate2'
						  ),
					titleVn: currentItem.IsReceiptDecree70
						? me.$t(
								'i18nInvoice.CheckingResult.InvoiceRelated.MissedInvoiceDateReceipt2',
								'vi'
						  )
						: me.$t(
								'i18nInvoice.CheckingResult.InvoiceRelated.MissedInvoiceDate2',
								'vi'
						  ),
				};
			}
			return '';
		},

		getTitleCheckingPaymentVatRate(currentItem, checkingResult) {
			const me = this;
			if (
				checkingResult.Payment.IsUpdateVatRateAccepted &&
				checkingResult.Payment.VatRate == me.validStatus
			) {
				return {
					title: me.$t('i18nInvoice.CheckingResult.Payment.VatRateAccepted'),
					titleVn: me.$t(
						'i18nInvoice.CheckingResult.Payment.VatRateAccepted',
						'vi'
					),
				};
			}
			return {
				title: me.$t('i18nInvoice.CheckingResult.Payment.InvalidVatRate'),
				titleVn: me.$t(
					'i18nInvoice.CheckingResult.Payment.InvalidVatRate',
					'vi'
				),
			};
		},

		getTitleCheckingPaymentTotalAmountNumber(currentItem, checkingResult) {
			const me = this;
			if (
				checkingResult.Payment.TotalAmountNumber ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				return {
					title: me.$t(
						'i18nInvoice.CheckingResult.Payment.InvalidTotalAmountNumber'
					),
					titleVn: me.$t(
						'i18nInvoice.CheckingResult.Payment.InvalidTotalAmountNumber',
						'vi'
					),
				};
			}
			return '';
		},

		getTitleCheckingPaymentTotalAmountWord(currentItem, checkingResult) {
			const me = this;
			if (
				checkingResult.Payment.TotalAmountWord ==
				me.$ms.enum.CheckingStatus.Invalid
			) {
				return {
					title: me.$t(
						'i18nInvoice.CheckingResult.Payment.InvalidTotalAmountWord'
					),
					titleVn: me.$t(
						'i18nInvoice.CheckingResult.Payment.InvalidTotalAmountWord',
						'vi'
					),
				};
			}
			return '';
		},

		autoScaleTextReason(e) {
			const me = this;
			let reasonEle = document.querySelector('.enter-reason');
			const textarea = document.querySelector('.ms-input-item');
			if (reasonEle && textarea) {
				reasonEle.style.height = '36px';
				const newHeight = textarea.scrollHeight;
				let maxHeight = 100;
				reasonEle.style.height = Math.min(newHeight, 100) + 'px';
				if (newHeight <= 100) {
					textarea.style.overflow = 'hidden';
				} else {
					textarea.style.overflow = 'auto';
				}
			}
		},
		afterAppendChild(payload) {
			const me = this;
			if (payload) {
				me.autoScaleTextReason();
			}
		},

		async updateAcceptedCheckingResultAsync(type, invoiceId, checkingResult) {
			const me = this;
			if (!invoiceId) return false;
			if (!checkingResult) {
				checkingResult = {};
			}

			checkingResult.Commodity.CheckingResultFlags = type;
			let payload = {
				InvoiceId: invoiceId,
				CheckingResult: checkingResult,
			};
			return await me.updateAcceptedCheckingResult(payload);
		},

		resetCheckingResult(
			type,
			isUpdateNew = true,
			checkingResult,
			checkingResultPrevios
		) {
			const me = this;
			if (
				!checkingResultPrevios ||
				!checkingResult ||
				!checkingResultPrevios.Commodity ||
				!checkingResult.Commodity
			)
				return;

			if (type == me.$ms.enum.CheckingResultEnum.UnitName) {
				if (
					!checkingResultPrevios.Commodity.UnitNameAcceptInfos ||
					!checkingResult.Commodity.UnitNameAcceptInfos
				)
					return;
				me.resetCheckingResultTemplateCommodityUnitName(isUpdateNew);
			} else if (type == me.$ms.enum.CheckingResultEnum.Quantity) {
				if (
					!checkingResultPrevios.Commodity.QuantityAcceptInfos ||
					!checkingResult.Commodity.QuantityAcceptInfos
				)
					me.resetCheckingResultTemplateCommodityQuantity(isUpdateNew);
				return;
			} else if (type == me.$ms.enum.CheckingResultEnum.UnitPrice) {
				if (
					!checkingResultPrevios.Commodity.UnitPriceAcceptInfos ||
					!checkingResult.Commodity.UnitPriceAcceptInfos
				)
					return;
				me.resetCheckingResultTemplateCommodityUnitPrice(isUpdateNew);
			}
		},

		closeUnitNameDropdown() {
			const me = this;
			const templateCommodityUnitName = me.$refs.templateCommodityUnitName;
			if (!templateCommodityUnitName) return;
			templateCommodityUnitName.closeTemplateUnitNameDropDown();
		},

		closeQuantityDropdown() {
			const me = this;
			const templateCommodityQuantity = me.$refs.templateCommodityQuantity;
			if (!templateCommodityQuantity) return;
			templateCommodityQuantity.closeTemplateQuantityDropDown();
		},

		closeUnitPriceDropdown() {
			const me = this;
			const templateCommodityUnitPrice = me.$refs.templateCommodityUnitPrice;
			if (!templateCommodityUnitPrice) return;
			templateCommodityUnitPrice.closeTemplateUnitPriceDropDown();
		},

		closeDropdownByType(type) {
			const me = this;
			switch (type) {
				case me.$ms.enum.CheckingResultEnum.UnitName:
					me.closeUnitNameDropdown();
					break;
				case me.$ms.enum.CheckingResultEnum.Quantity:
					me.closeQuantityDropdown();
					break;
				case me.$ms.enum.CheckingResultEnum.UnitPrice:
					me.closeUnitPriceDropdown();
					break;
				default:
					break;
			}
		},

		resetCheckingResultTemplateCommodityUnitName(isUpdateNew = true) {
			const me = this;
			const templateCommodityUnitName = me.$refs.templateCommodityUnitName;
			if (!templateCommodityUnitName) return;
			if (isUpdateNew) {
				templateCommodityUnitName.resetDataUnitNameAcceptInfosOld();
			} else {
				templateCommodityUnitName.resetDataUnitNameAcceptInfos();
			}
		},

		resetCheckingResultTemplateCommodityQuantity(isUpdateNew = true) {
			const me = this;
			const templateCommodityQuantity = me.$refs.templateCommodityQuantity;
			if (!templateCommodityQuantity) return;
			if (isUpdateNew) {
				templateCommodityQuantity.resetDataQuantityAcceptInfosOld();
			} else {
				templateCommodityQuantity.resetDataQuantityAcceptInfos();
			}
		},

		resetCheckingResultTemplateCommodityUnitPrice(isUpdateNew = true) {
			const me = this;
			const templateCommodityUnitPrice = me.$refs.templateCommodityUnitPrice;
			if (!templateCommodityUnitPrice) return;
			if (isUpdateNew) {
				templateCommodityUnitPrice.resetDataUnitPriceAcceptInfosOld();
			} else {
				templateCommodityUnitPrice.resetDataUnitPriceAcceptInfos();
			}
		},

		resetCheckingResultTemplateCommodityByType(type, isUpdateNew = true) {
			const me = this;
			switch (type) {
				case me.$ms.enum.CheckingResultEnum.UnitName:
					me.resetCheckingResultTemplateCommodityUnitName(isUpdateNew);
					break;
				case me.$ms.enum.CheckingResultEnum.Quantity:
					me.resetCheckingResultTemplateCommodityQuantity(isUpdateNew);
					break;
				case me.$ms.enum.CheckingResultEnum.UnitPrice:
					me.resetCheckingResultTemplateCommodityUnitPrice(isUpdateNew);
					break;
				default:
					break;
			}
		},

		async changeAcceptCommodity(
			type,
			currentItem,
			checkingResult,
			isFollowAvaChat = true
		) {
			const me = this;
			if (!type || !currentItem || !currentItem.InvoiceId || !checkingResult) {
				return;
			}

			//Update dữ liệu
			let res = await me.updateAcceptedCheckingResultAsync(
				type,
				currentItem.InvoiceId,
				checkingResult
			);
			let updateSuccess = res && res.Success && res.Data;
			if (updateSuccess) {
				me.$ms.commonFunc.toast({
					type: 'success',
					text: `${me.$t('i18nInvoice.InvoiceInbot.UpdateSuccess')}`,
					position: 'top-center',
				});
			}
			me.resetCheckingResultTemplateCommodityByType(type, updateSuccess);
			me.closeDropdownByType(type);

			if (!updateSuccess) return;
			//Lấy dữ liệu cũ để thực hiện gắn lại dữ liệu khi reloadCriteriaInvoice thì vẫn còn dữ liệu cũ
			let commodityOld = me.$ms.commonFunc.cloneDeepData(
				checkingResult.Commodity
			);

			//Update dữ liệu trả về từ server
			checkingResult.Commodity = res.Data.Commodity;

			if (isFollowAvaChat) {
				//Gán dữ liệu emit để reloadCriteriaInvoice
				if (commodityOld.IsUpdateUnitAccepted)
					checkingResult.Commodity.IsUpdateUnitAccepted = true;
				if (commodityOld.IsUpdateQuantityAccepted)
					checkingResult.Commodity.IsUpdateQuantityAccepted = true;
				if (commodityOld.IsUpdateUnitPriceAccepted)
					checkingResult.Commodity.IsUpdateUnitPriceAccepted = true;

				if (type == me.$ms.enum.CheckingResultEnum.UnitName) {
					checkingResult.Commodity.IsUpdateUnitAccepted = true;
				} else if (type == me.$ms.enum.CheckingResultEnum.Quantity) {
					checkingResult.Commodity.IsUpdateQuantityAccepted = true;
				} else if (type == me.$ms.enum.CheckingResultEnum.UnitPrice) {
					checkingResult.Commodity.IsUpdateUnitPriceAccepted = true;
				}
			}

			me.$emit('reloadCheckingResult', {
				CheckingResult: checkingResult,
				Status: res.Data.StatusInvoice,
				type: type,
			});
		},

		getMessageCheckedAdvanceBaseV2(currentItem, checkingResult, type) {
			const me = this;
			let result = {};
			if (
				!checkingResult.OnInvoice &&
				checkingResult.Status == me.$ms.enum.CheckingStatus.Invalid
			) {
				result = {
					text: me.$t(`i18nInvoice.Invoice.${type}Unknown`),
					textVn: me.$t(`i18nInvoice.Invoice.${type}Unknown`, 'vi'),
				};
			} else if (
				checkingResult &&
				checkingResult.Status == me.$ms.enum.CheckingStatus.Valid
			) {
				// Với TH là vé và các thông tin k có thông tin trong HĐ
				if (
					currentItem.IsTicketAdvance &&
					checkingResult &&
					(type == 'BuyerName' ||
						type == 'BuyerAddress' ||
						type == 'BuyerTaxCode') &&
					!checkingResult.OnInvoice
				) {
					result = {
						text: me.$t(`i18nInvoice.Invoice.${type}Unknown`),
						textVn: me.$t(`i18nInvoice.Invoice.${type}Unknown`, 'vi'),
					};
					return result;
				} else if (
					currentItem.IsCheckReceipt &&
					(type == 'BuyerName' ||
						type == 'BuyerAddress' ||
						type == 'BuyerTaxCode') &&
					!checkingResult.OnInvoice &&
					!checkingResult.IsAccepted
				) {
					result = {
						text: me.$t(`i18nInvoice.Invoice.${type}Unknown`),
						textVn: me.$t(`i18nInvoice.Invoice.${type}Unknown`, 'vi'),
					};
				} else {
					result = {
						text: me.$t(`i18nInvoice.Invoice.${type}Valid`),
						textVn: me.$t(`i18nInvoice.Invoice.${type}Valid`, 'vi'),
					};
				}
			} else if (
				checkingResult &&
				checkingResult.Status == me.$ms.enum.CheckingStatus.Unknown
			) {
				result = {
					text: me.$t(`i18nInvoice.Invoice.${type}Unknown`),
					textVn: me.$t(`i18nInvoice.Invoice.${type}Unknown`, 'vi'),
				};
			} else if (
				checkingResult &&
				checkingResult.Status == me.$ms.enum.CheckingStatus.Invalid
			) {
				result = {
					text: me.$t(`i18nInvoice.Invoice.${type}Invalid`),
					textVn: me.$t(`i18nInvoice.Invoice.${type}Invalid`, 'vi'),
				};
			} else {
				result = {
					text: me.$t(`i18nInvoice.Invoice.${type}Unchecked`),
					textVn: me.$t(`i18nInvoice.Invoice.${type}Unchecked`, 'vi'),
				};
			}

			result = me.standardTextForReceipt(currentItem, result);
			return result;
		},

		standardTextForReceipt(currentItem, result) {
			const me = this;
			if (!currentItem.IsCheckReceipt) return result;

			//15.08.2022 NNTHAO Không sử dụng được .replaceAll do WebView của SME không có hàm này
			do {
				result = {
					text: result.text.replace(
						`${me.$t('i18nCommon.invoice')}`,
						`${me.$t('i18nCommon.receipt')}`
					),
					textVn: result.textVn.replace(
						`${me.$t('i18nCommon.invoice', 'vi')}`,
						`${me.$t('i18nCommon.receipt', 'vi')}`
					),
				};

				result = {
					text: result.text.replace(
						`${me.$t('i18nCommon.Invoice')}`,
						`${me.$t('i18nCommon.Receipt')}`
					),
					textVn: result.textVn.replace(
						`${me.$t('i18nCommon.Invoice', 'vi')}`,
						`${me.$t('i18nCommon.Receipt', 'vi')}`
					),
				};
			} while (
				result.text.contains(`${me.$t('i18nCommon.invoice')}`) ||
				result.text.contains(`${me.$t('i18nCommon.Invoice')}`)
			);

			return result;
		},
	},
};
</script>
<style lang="scss" scoped></style>
